import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { lg, xs } from '@exonet/react-shared/lib/styled';
import { hoverScale } from 'app/client/styled/animations';

const iconSize = '16px';

const Animated = css`
  &&& {
    &:hover {
      color: var(--menu-text-active);

      :before {
        background-color: var(--menu-text-active);
      }
    }
  }
`;

export const Toggle = styled.button.attrs({
  type: 'button',
})`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  cursor: pointer;
  border: 0;

  background-color: transparent;
  padding: var(--xs-padding);
  padding-left: 6px;
  color: ${({ active }) => (active ? 'var(--menu-text-active)' : 'var(--menu-text)')};

  ${({ active }) =>
    active &&
    css`
      background-color: var(--menu-active-bg);
    `}
  ${lg(css`
    padding: var(--xs-padding-vertical) var(--sm-padding-horizontal);
  `)}
  > span:not(:first-child) {
    flex: 1 1 auto;
    text-align: left;
    color: inherit;
  }

  > svg {
    flex: 0 0 auto;
    fill: ${({ active }) => (active ? 'var(--menu-text-active)' : 'var(--menu-text)')};
    width: ${iconSize} !important;
    height: ${iconSize} !important;

    &:last-child {
      margin-right: 0;
      transform: rotate(90deg);
      width: 10px !important;
      height: 10px !important;

      ${({ open }) =>
        open &&
        css`
          transform: rotate(270deg);
        `}
    }
  }

  &:focus {
    outline: none;
  }

  ${xs(css`
    ${({ active }) => !active && Animated})
  `)}
`;

export const Link = styled(NavLink)`
  &,
  &:active,
  &:focus,
  &:visited {
    display: flex;
    flex: 1 1 auto;
    color: inherit !important;
    align-items: center;
    ${({ $nested }) =>
      !$nested &&
      css`
        width: 100%;
        padding: var(--xs-padding);
        padding-left: 6px;
      `}

    &::before {
      display: none;
    }
  }

  ${lg(css`
    &,
    &:active,
    &:focus,
    &:visited {
      ${({ $nested }) =>
        !$nested &&
        css`
          padding: var(--xs-padding-vertical) var(--sm-padding-horizontal);
        `}
    }
  `)}
`;

export const MenuItem = styled.li`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  color: ${({ active }) => (active ? 'var(--menu-text-active)' : 'var(--menu-text)')};
  background-color: ${({ active }) => active && css`var(--menu-active-bg)`};

  ${Animated}
`;

export const MenuGroup = styled.li`
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  color: var(--menu-text);
  scroll-margin-bottom: 48px;
`;

export const SubMenu = styled.div`
  max-height: 0;
  overflow: hidden;
  transition:
    max-height 0.4s ease,
    opacity 0.4s ease;
  opacity: 0;

  ${({ visible }) =>
    visible &&
    css`
      max-height: 500px;
      opacity: 1;
    `}
  > ul {
    padding: var(--xs-padding-vertical) 0 !important;
    font-size: var(--sm-font-size);

    > li {
      background-color: transparent;
      padding: var(--xs-padding-vertical) var(--xs-padding-horizontal);

      :before {
        content: '';
        width: 6px;
        height: 2px;
        background-color: var(--menu-text);
        margin-left: 7px;
        margin-right: 25px;
        transition: all 0.4s ease-in-out;
      }

      ${lg(css`
        padding: var(--xs-padding-vertical) var(--lg-padding-horizontal);

        :before {
          margin-left: 7px;
        }
      `)}
    }
  }
`;

export const IconCircle = styled.span`
  margin-right: var(--xs-padding-horizontal);
  padding: var(--xs-padding-vertical);
  background-color: transparent;
  border-radius: 50%;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  ${hoverScale({
    hoverScaleValue: 1.2,
    activeScaleValue: 1.05,
    durationMs: 160,
    triggerSelector: [MenuItem, Toggle],
    targetSelector: '&',
  })}

  ${({ active }) =>
    active &&
    css`
      background-color: var(--menu-active-icon-bg, var(--link));

      > svg {
        fill: var(--menu-text-active);
      }
    `}
  > svg {
    fill: var(--menu-text);
    width: ${iconSize} !important;
    height: ${iconSize} !important;
  }
`;

export const MobileToggle = styled.button``;
